var _style, _path;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNewtab = function SvgNewtab(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0050B3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.08,10.04H3.76V8.76h0h2.32V6.44h1.28v2.32h2.32v1.28H7.36v2.32H6.08v0V10.04z M15.36,0L15.36,0L3.04,0 C2.95,0,2.88,0.07,2.88,0.16v1.12c0,0.09,0.07,0.16,0.16,0.16h11.52v11.52c0,0.09,0.07,0.16,0.16,0.16h1.12 c0.09,0,0.16-0.07,0.16-0.16V0.64C16,0.29,15.71,0,15.36,0z M13.44,3.2v12.16c0,0.35-0.29,0.64-0.64,0.64H0.64c0,0,0,0,0,0 C0.29,16,0,15.71,0,15.36V3.2c0-0.35,0.29-0.64,0.64-0.64H12.8C13.15,2.56,13.44,2.85,13.44,3.2z M12,4H1.44v10.56H12V4z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewtab, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/newtab.6b712159.svg";
export { ForwardRef as ReactComponent };